import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const BASE = 'https://drivemaster.se';

/**
 * Global SEO component that sets canonical URL and fallback description for every page.
 * Pages with their own Helmet (SEO.js, DetailPages) will override this.
 */
const DynamicSEO = () => {
  const { pathname } = useLocation();
  
  // Normalize: remove trailing slash (except root)
  const cleanPath = pathname === '/' ? '' : pathname.replace(/\/$/, '');
  const canonical = cleanPath ? `${BASE}${cleanPath}` : BASE;
  
  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
      <meta name="description" content="DriveMaster - Gratis teoriprov 2026! 800+ B-körkort-frågor + 480+ Taxi-frågor, 33 övningsprov på 9 språk. Klara körkortsteori!" />
    </Helmet>
  );
};

export default DynamicSEO;
